import { Input, Label } from "@opero/ui";
import { Plus, X } from "lucide-react";

export interface InvitationEntry {
  id: string;
  email: string;
}

interface InvitationsSectionProps {
  entries: InvitationEntry[];
  onChange: (next: InvitationEntry[]) => void;
}

export function InvitationsSection({
  entries,
  onChange,
}: InvitationsSectionProps) {
  const add = () =>
    onChange([...entries, { id: crypto.randomUUID(), email: "" }]);
  const update = (id: string, email: string) =>
    onChange(entries.map((e) => (e.id === id ? { ...e, email } : e)));
  const remove = (id: string) =>
    onChange(entries.filter((e) => e.id !== id));

  return (
    <section className="space-y-3">
      <header>
        <h2 className="text-lg font-semibold text-slate-900 dark:text-white">
          Invite teammates
        </h2>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Optional — you can do this later from the workspace.
        </p>
      </header>

      <div className="space-y-3">
        {entries.map((entry, i) => (
          <div key={entry.id} className="flex gap-2">
            <div className="flex-1 space-y-1.5">
              {i === 0 && <Label>Email addresses</Label>}
              <Input
                type="email"
                value={entry.email}
                onChange={(e) => update(entry.id, e.target.value)}
                placeholder="colleague@company.com"
              />
            </div>
            {entries.length > 1 && (
              <button
                type="button"
                onClick={() => remove(entry.id)}
                className={`shrink-0 rounded-lg p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors ${
                  i === 0 ? "mt-7" : ""
                }`}
              >
                <X size={16} />
              </button>
            )}
          </div>
        ))}

        <button
          type="button"
          onClick={add}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400"
        >
          <Plus size={14} /> Add another
        </button>
      </div>
    </section>
  );
}
